/* eslint semi:0 */
import { namespacedConsts, } from 'utils/object'
import { dispatchAction, } from 'application/AppDispatcher'

const CLASS_CONSTATNTS = namespacedConsts({
  SOCIAL_BUTTONS: {
    ACTIONS: {
      FACEBOOK_SHARE: true,
      TWITTER_SHARE: true,
      WHATSAPP_SHARE: true,
      COMMENTS_TOGGLE: true,
      EMBED_OPEN: true,
      EMBED_CLOSE: true,
    },
  },
})

let socialButtonsActions = {

  TYPES: CLASS_CONSTATNTS.SOCIAL_BUTTONS.ACTIONS,

  facebookShare: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.FACEBOOK_SHARE,
      e,
    })
  },

  twitterShare: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.TWITTER_SHARE,
      e,
    })
  },

  whatsappShare: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.WHATSAPP_SHARE,
      e,
    })
  },

  openEmbed: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.EMBED_OPEN,
    })
  },

  closeEmbed: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.EMBED_CLOSE,
    })
  },

  commentsToggle: (caller, e) => {
    dispatchAction.view({
      type: socialButtonsActions.TYPES.COMMENTS_TOGGLE,
      e,
    })
  },

}

export const socialButtonsActionTypes = socialButtonsActions.TYPES;

export default socialButtonsActions


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/socialButtonsActions.js